/*
 * Berry — selecteur de pages en haut de collection.
 * Chips (fenetre fournie par Shopify paginate.parts) + champ « Aller a la page ».
 * Clic sur un numero :
 *   - si la page est deja chargee (separateur #berry-page-N present) -> defilement doux (pas de rechargement)
 *   - sinon -> navigation reelle ?page=N (scalable pour grosses collections)
 * Surligne le numero de la page courante au scroll.
 */
(function () {
  if (customElements.get('berry-page-nav')) return;

  class BerryPageNav extends HTMLElement {
    connectedCallback() {
      this.pages = parseInt(this.getAttribute('data-pages'), 10) || 1;
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.tick = false;

      this.addEventListener('click', this.onClick);

      var form = this.querySelector('.berry-page-nav__go');
      var input = this.querySelector('.berry-page-nav__input');
      if (form && input) {
        form.addEventListener('submit', (e) => { e.preventDefault(); this.go(input.value); });
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onClick(e) {
      var chip = e.target.closest('.berry-page-nav__chip');
      if (!chip || !this.contains(chip)) return;
      var n = parseInt(chip.getAttribute('data-page'), 10);
      if (!n) return;
      var sep = document.getElementById('berry-page-' + n);
      if (sep) {
        // page deja chargee -> on defile sans recharger
        e.preventDefault();
        sep.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.setActive(n);
      }
      // sinon : c'est un lien <a href ?page=N> -> navigation native
    }

    go(val) {
      var n = parseInt(val, 10);
      if (!n || n < 1) return;
      if (n > this.pages) n = this.pages;
      var sep = document.getElementById('berry-page-' + n);
      if (sep) {
        sep.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.setActive(n);
        return;
      }
      var u = new URL(window.location.href);
      u.searchParams.set('page', String(n));
      u.hash = '';
      window.location.assign(u.toString());
    }

    setActive(n) {
      var chips = this.querySelectorAll('.berry-page-nav__chip');
      for (var i = 0; i < chips.length; i++) {
        var cn = parseInt(chips[i].getAttribute('data-page'), 10);
        chips[i].classList.toggle('is-current', cn === n);
      }
    }

    onScroll() {
      if (this.tick) return;
      this.tick = true;
      var self = this;
      requestAnimationFrame(function () {
        self.tick = false;
        var seps = document.querySelectorAll('.berry-page-sep');
        var cur = null;
        for (var i = 0; i < seps.length; i++) {
          if (seps[i].getBoundingClientRect().top <= 120) cur = seps[i].getAttribute('data-page');
        }
        if (cur) self.setActive(parseInt(cur, 10));
      });
    }
  }

  customElements.define('berry-page-nav', BerryPageNav);
})();
